import request from "../config/axios-config";

export function getUserDetails() {
  return request({
    url: "/user/details",
    method: "get"
  });
}

export function getUsers() {
  return request({
    method: "get",
    url: "/user/all"
  });
}

export function saveOwnSignature(image, expectedSignatureLink) {
  const formData = new FormData();
  formData.append("file", image, "signature.png");
  if (expectedSignatureLink) formData.append("expectedSignatureLink", expectedSignatureLink);
  return request({ method: expectedSignatureLink ? "put" : "post", url: "/user/signature", data: formData });
}

export function getOwnSignatureImage() {
  return request({ method: "get", url: "/user/signature/image", responseType: "blob" });
}

export function deleteOwnSignature(expectedSignatureLink) {
  return request({ method: "delete", url: "/user/signature", params: { expectedSignatureLink } });
}

export const uploadSignature = async (file, userId) => {
  let formData = new FormData();
  formData.append("file", file);

  return request({
    method: "post",
    url: "/user/upload/signature/" + userId,
    data: formData
  });
};
